export default {"src":"/_next/static/media/AppDownloadGooglePlay.425d7db6.svg","height":61,"width":192,"blurWidth":0,"blurHeight":0};